module.exports = __webpack_public_path__ + "static/media/gsda_logo.e8975261.jpg";